// Central site configuration: contact, services, zones, faq, reviews.

export const SITE = {
  name: "Termite Bordeaux",
  legalName: "Termite Bordeaux",
  displayBrand: "Termite Bordeaux",
  brandTagline: "par Termite Habitat 33",
  domain: "termitebordeaux.fr",
  url: "https://termitebordeaux.fr",
  parentSite: "https://termitehabitat33.fr",
  parentSiteLabel: "termitehabitat33.fr",
  googleBusinessUrl: "https://share.google/hzwIJ05tCMqpzsWu9",
  googleMapsCanonical:
    "https://www.google.com/search?q=Termite+habitat+33+%22traitement+termite,+bois+et+charpente%22&kgmid=/g/11vt1_3rly",
  googleKgmid: "/g/11vt1_3rly",
  facebook: "https://www.facebook.com/profile.php?id=61570838585826",
  tagline: "Expert termites & traitement du bois en Gironde",
  phone: "07 45 71 15 10",
  phoneRaw: "+33745711510",
  email: "termitehabitat33@gmail.com",
  address: "53 avenue de la forêt d'Arboudeau",
  postalCode: "33290",
  city: "Parempuyre",
  region: "Nouvelle-Aquitaine",
  country: "France",
  hours: "Lun–Sam · 8h–19h",
  geo: { lat: 44.9619, lng: -0.6 },
  guarantee: "Garantie 5 ans : retraitement gratuit en cas de nouvelle infestation",
  guaranteeShort: "Garantie 5 ans",
  aggregateRating: { value: 5.0, count: 12 },
  // Champ lexical riche pour le SEO local
  seoKeywords: [
    "traitement termites Bordeaux",
    "termites Bordeaux",
    "entreprise termites Bordeaux",
    "expertise termites Bordeaux",
    "traitement bois Bordeaux",
    "traitement charpente Bordeaux",
    "termites Gironde",
    "anti-termites Bordeaux",
    "exterminateur termites Bordeaux",
    "professionnel termites Gironde",
    "insectes xylophages Bordeaux",
    "capricornes maison Bordeaux",
    "vrillettes Bordeaux",
    "mérule Bordeaux",
    "humidité charpente Gironde",
    "traitement préventif termites",
    "injection termites Bordeaux",
    "piège termites Bordeaux",
    "bois infesté Gironde",
    "protection habitat termites",
  ],
};

export const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/insectes-xylophages", label: "Insectes xylophages" },
  { to: "/zones", label: "Zones" },
  { to: "/galerie", label: "Galerie" },
  { to: "/photos", label: "Photos" },
  { to: "/blog", label: "Blog" },
  { to: "/avis", label: "Avis" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    slug: "traitement-termites-bordeaux",
    title: "Traitement termites",
    seoTitle: "Traitement termites Bordeaux & Gironde — Injection, pièges-appâts",
    short: "Éradication par injection sous pression ou pièges‑appâts.",
    icon: "Bug",
    keywords: ["traitement termites Bordeaux", "termites Bordeaux", "termites Gironde", "anti-termites Bordeaux"],
    body: [
      "Le traitement des termites souterrains à Bordeaux exige une approche méthodique adaptée au climat humide de la Garonne et à la nature des bâtis girondins, souvent en pierre calcaire avec planchers et solives en chêne. Nous intervenons en deux protocoles complémentaires : l'injection sous pression directe dans les bois et maçonneries infestés, ou la pose de pièges‑appâts en périmètre extérieur pour stopper la colonie à la source.",
      "L'injection se réalise après expertise, en perçant les bois porteurs à intervalles réguliers et en saturant les galeries d'un produit biocide rémanent homologué. Cette méthode offre un effet barrière immédiat et convient particulièrement aux maisons anciennes du centre de Bordeaux ou aux échoppes des Chartrons.",
      "Les pièges‑appâts, eux, exploitent le comportement social des termites : les ouvriers transportent l'appât dans le nid, contaminant la reine et l'ensemble de la colonie. Plus discret, ce protocole est idéal pour les copropriétés, les bâtiments classés et les habitations entourées de jardin.",
    ],
  },
  {
    slug: "traitement-bois-charpente",
    title: "Traitement bois & charpente",
    seoTitle: "Traitement charpente & bois Bordeaux — Capricornes, vrillettes",
    short: "Bois infesté par capricornes, vrillettes et autres xylophages.",
    icon: "Trees",
    keywords: ["traitement bois Bordeaux", "traitement charpente Bordeaux", "capricornes", "vrillettes"],
    body: [
      "Les charpentes traditionnelles de Gironde — chêne, pin maritime, châtaignier — sont régulièrement attaquées par des insectes xylophages : capricorne des maisons, grosse et petite vrillette, lyctus. Sans intervention, ces nuisibles fragilisent la structure portante en quelques années.",
      "Notre traitement combine un brossage et dépoussiérage des bois, un sondage acoustique pour localiser les zones creuses, un bûchage des parties altérées puis une double application par pulvérisation et injection à cœur. Le produit utilisé est insecticide et fongicide, certifié CTB‑P+.",
      "Chaque chantier fait l'objet d'un procès‑verbal de traitement remis au propriétaire, indispensable pour la revente et les assurances habitation.",
    ],
  },
  {
    slug: "traitement-preventif",
    title: "Traitement préventif",
    seoTitle: "Traitement préventif termites Bordeaux — Protection habitat",
    short: "Barrière chimique pour neufs et constructions anciennes.",
    icon: "Shield",
    keywords: ["traitement préventif", "protection habitat", "injection termites"],
    body: [
      "La meilleure défense contre les termites reste la prévention. Pour les constructions neuves, la réglementation impose un dispositif de protection contre les termites dès la dalle. Pour l'ancien, un traitement préventif périodique évite tout retour de colonie.",
      "Nous installons des barrières physico‑chimiques en pied de mur, autour des fondations et au niveau des bois de structure. La méthode peut s'accompagner d'un système de bornes de surveillance, contrôlées une à deux fois par an.",
      "Cette protection se révèle particulièrement pertinente sur les biens proches de la Garonne, dans les communes de Bègles, Floirac ou Lormont, où l'humidité du sol favorise la remontée des essaims.",
    ],
  },
  {
    slug: "traitement-merule",
    title: "Traitement de la mérule",
    seoTitle: "Traitement mérule Bordeaux & Gironde — Champignon lignivore",
    short: "Champignon lignivore : éradication et assainissement.",
    icon: "Droplet",
    keywords: ["mérule", "humidité charpente", "champignon bois Bordeaux", "mérule Bordeaux"],
    body: [
      "La mérule pleureuse (Serpula lacrymans) est le pire ennemi des maisons girondines anciennes. Elle prospère dans les murs humides, derrière les plâtres, dans les caves et sous les planchers, et peut digérer le bois en quelques mois.",
      "Notre intervention démarre par une recherche d'humidité (sondes capacitives, thermographie) puis une dépose des matériaux contaminés. Nous procédons ensuite à un brûlage de surface, à une stérilisation des maçonneries par injection de fongicide à cœur et au remplacement des bois irrécupérables.",
      "Sans traitement de l'origine de l'humidité (infiltrations, remontées capillaires, condensation), tout traitement curatif reste éphémère. Nous proposons donc systématiquement un audit humidité complémentaire.",
    ],
  },
  {
    slug: "traitement-humidite",
    title: "Traitement humidité",
    seoTitle: "Traitement humidité Bordeaux — Remontées capillaires, caves",
    short: "Remontées capillaires, infiltrations, condensation : assainissement complet.",
    icon: "Waves",
    keywords: ["traitement humidité Bordeaux", "remontées capillaires Bordeaux", "humidité cave Gironde"],
    body: [
      "L'humidité est le facteur n°1 d'apparition des termites et de la mérule en Gironde. Les bâtis bordelais en pierre, les caves voûtées et les murs à la chaux sont particulièrement sujets aux remontées capillaires et aux infiltrations de surface.",
      "Notre cabinet propose un audit humidité complet : sondes capacitives et résistives, thermographie infrarouge, recherche de pont thermique, contrôle de la ventilation. Sur la base de l'expertise, nous proposons un protocole d'assainissement adapté : injection de résine hydrophobe, drains périphériques, VMC hygroréglable, enduits respirants à la chaux.",
      "Sans traitement de l'humidité, aucun traitement termites ou mérule n'est durable. C'est pourquoi nous intégrons systématiquement cet audit dans nos interventions.",
    ],
  },
];

export const ZONES = [
  { slug: "bordeaux", name: "Bordeaux", insee: "33063", postal: "33000-33800",
    blurb: "Centre historique, échoppes, hôtels particuliers : un terrain propice aux termites souterrains.",
    neighborhoods: ["Chartrons", "Saint-Pierre", "Saint-Michel", "Capucins", "Caudéran", "Saint-Augustin", "La Bastide", "Bacalan", "Le Lac", "Nansouty"] },
  { slug: "merignac", name: "Mérignac", insee: "33281", postal: "33700",
    blurb: "Lotissements pavillonnaires et maisons en pierre : interventions fréquentes en charpente.",
    neighborhoods: ["Centre", "Arlac", "Capeyron", "Beutre", "Chemin Long", "Pichey"] },
  { slug: "pessac", name: "Pessac", insee: "33318", postal: "33600",
    blurb: "Quartiers résidentiels et bâtis en bois : capricornes et vrillettes très présents.",
    neighborhoods: ["Centre", "Saige", "Le Burck", "Bersol", "Toctoucau", "Cap-de-Bos"] },
  { slug: "talence", name: "Talence", insee: "33522", postal: "33400",
    blurb: "Maisons bourgeoises proche campus : expertises avant vente très demandées.",
    neighborhoods: ["Centre", "Thouars", "Médoquine", "Peixotto"] },
  { slug: "begles", name: "Bègles", insee: "33039", postal: "33130",
    blurb: "Proximité Garonne, humidité forte, risque mérule accru en cave.",
    neighborhoods: ["Centre", "Terres Neuves", "Carle Vernet", "Mussonville"] },
  { slug: "le-bouscat", name: "Le Bouscat", insee: "33069", postal: "33110",
    blurb: "Échoppes et maisons des années 1900 : charpentes en chêne très ciblées.",
    neighborhoods: ["Centre", "Champ de Courses", "Hippodrome", "Sainte-Anne"] },
  { slug: "bruges", name: "Bruges", insee: "33075", postal: "33520",
    blurb: "Zone humide, sol argileux : prévention indispensable contre les termites souterrains.",
    neighborhoods: ["Centre", "Le Tasta", "Le Petit Bruges"] },
  { slug: "eysines", name: "Eysines", insee: "33162", postal: "33320",
    blurb: "Maraîchage et bois ancien : alerte capricornes signalée chaque année.",
    neighborhoods: ["Centre", "Le Vigean", "Migron", "Lescombes"] },
  { slug: "villenave-d-ornon", name: "Villenave-d'Ornon", insee: "33550", postal: "33140",
    blurb: "Pavillons individuels : traitement préventif fortement recommandé.",
    neighborhoods: ["Centre", "Chambéry", "Sallegourde", "Geneste"] },
  { slug: "cenon", name: "Cenon", insee: "33119", postal: "33150",
    blurb: "Bâtis collectifs et maisons sur les coteaux : risque mérule en sous-sol.",
    neighborhoods: ["Centre", "Palmer", "La Marègue", "Beausite"] },
  { slug: "lormont", name: "Lormont", insee: "33249", postal: "33310",
    blurb: "Berges de la Garonne, ouvrages anciens : termites et humidité combinés.",
    neighborhoods: ["Centre", "Génicart", "Carriet", "Bois Fleuri"] },
  { slug: "floirac", name: "Floirac", insee: "33167", postal: "33270",
    blurb: "Zone sensible aux remontées capillaires et infestations termites.",
    neighborhoods: ["Centre", "Dravemont", "Pelletan", "Souys"] },
  { slug: "gradignan", name: "Gradignan", insee: "33192", postal: "33170",
    blurb: "Pavillons en lisière de bois : insectes xylophages très actifs.",
    neighborhoods: ["Centre", "Malartic", "Mandavit", "Cayac"] },
  { slug: "parempuyre", name: "Parempuyre", insee: "33312", postal: "33290",
    blurb: "Notre commune d'attache : interventions express en moins de 24 h.",
    neighborhoods: ["Centre", "Garros", "Landegrand"] },
  { slug: "saint-medard-en-jalles", name: "Saint-Médard-en-Jalles", insee: "33449", postal: "33160",
    blurb: "Grandes propriétés bordées de pins : surveillance termites essentielle.",
    neighborhoods: ["Centre", "Magudas", "Issac", "Hastignan"] },
  { slug: "blanquefort", name: "Blanquefort", insee: "33056", postal: "33290",
    blurb: "Zones viticoles et chais en bois : traitement charpente régulier.",
    neighborhoods: ["Centre", "Caychac", "Linas"] },
  { slug: "libourne", name: "Libourne", insee: "33243", postal: "33500",
    blurb: "Cœur de Saint‑Émilion : châteaux et caves traités contre la mérule.",
    neighborhoods: ["Centre", "La Ballastière", "Le Verdet"] },
  { slug: "arcachon", name: "Arcachon", insee: "33009", postal: "33120",
    blurb: "Villas du bassin : sel, air iodé et termites côtiers.",
    neighborhoods: ["Ville d'Hiver", "Ville d'Été", "L'Aiguillon", "Le Moulleau"] },
  { slug: "la-teste-de-buch", name: "La Teste-de-Buch", insee: "33529", postal: "33260",
    blurb: "Bassin d'Arcachon, villas en bois et forêt usagère : risque xylophages.",
    neighborhoods: ["Centre", "Cazaux", "Pyla-sur-Mer"] },
  { slug: "andernos-les-bains", name: "Andernos-les-Bains", insee: "33005", postal: "33510",
    blurb: "Bassin nord : pins, humidité maritime, attaque vrillettes possible.",
    neighborhoods: ["Centre", "Le Mauret", "Le Bétey"] },
  { slug: "le-haillan", name: "Le Haillan", insee: "33200", postal: "33185",
    blurb: "Pavillonnaire ouest : copropriétés et lotissements à surveiller.",
    neighborhoods: ["Centre", "Bel Air", "Pinsoles"] },
  { slug: "saint-andre-de-cubzac", name: "Saint-André-de-Cubzac", insee: "33366", postal: "33240",
    blurb: "Cubzaguais et Blayais : maisons en pierre traitées chaque année.",
    neighborhoods: ["Centre", "Plagne", "Lafont"] },
  { slug: "bazas", name: "Bazas", insee: "33036", postal: "33430",
    blurb: "Bazadais : bâtis historiques, infestations capricornes signalées.",
    neighborhoods: ["Centre médiéval", "Cours d'Argent"] },
  { slug: "langon", name: "Langon", insee: "33227", postal: "33210",
    blurb: "Sud-Gironde : maisons girondines, intervention sur charpente.",
    neighborhoods: ["Centre", "Toulenne", "Mazères"] },
  { slug: "leognan", name: "Léognan", insee: "33238", postal: "33850",
    blurb: "Pessac-Léognan : châteaux viticoles, chais et résidences à protéger.",
    neighborhoods: ["Centre", "Domaine de Carbonnieux", "Sescas"] },
  { slug: "ambares-et-lagrave", name: "Ambarès-et-Lagrave", insee: "33003", postal: "33440",
    blurb: "Rive droite, terres humides et anciennes maisons cheminotes : termites fréquents.",
    neighborhoods: ["Centre", "La Gorp", "Sabaroots"] },
  { slug: "artigues-pres-bordeaux", name: "Artigues-près-Bordeaux", insee: "33013", postal: "33370",
    blurb: "Coteaux rive droite, propriétés bourgeoises et lotissements pavillonnaires.",
    neighborhoods: ["Centre", "Feydeau", "La Blancherie"] },
  { slug: "bassens", name: "Bassens", insee: "33032", postal: "33530",
    blurb: "Coteaux et zone portuaire : maisons anciennes très exposées à l'humidité.",
    neighborhoods: ["Centre", "Beauval", "Le Bousquet"] },
  { slug: "carbon-blanc", name: "Carbon-Blanc", insee: "33096", postal: "33560",
    blurb: "Rive droite, bâtis ouvriers du XXᵉ siècle, charpentes à surveiller.",
    neighborhoods: ["Centre", "Le Bourg", "Pelous"] },
  { slug: "sainte-eulalie", name: "Sainte-Eulalie", insee: "33419", postal: "33560",
    blurb: "Commune résidentielle dynamique entre Bordeaux et l'Entre-deux-Mers.",
    neighborhoods: ["Centre", "Bel Air", "Curé"] },
  { slug: "saint-loubes", name: "Saint-Loubès", insee: "33487", postal: "33450",
    blurb: "Entre-deux-Mers, maisons viticoles et grandes propriétés boisées.",
    neighborhoods: ["Centre", "Cantelaude", "Pied de Fond"] },
  { slug: "saint-aubin-de-medoc", name: "Saint-Aubin-de-Médoc", insee: "33376", postal: "33160",
    blurb: "Lisière du Médoc, pavillons en pin maritime : capricornes très actifs.",
    neighborhoods: ["Centre", "Marsouins", "Picot"] },
  { slug: "martignas-sur-jalle", name: "Martignas-sur-Jalle", insee: "33273", postal: "33127",
    blurb: "Ouest girondin, zones forestières, charpentes en résineux à protéger.",
    neighborhoods: ["Centre", "Bel Air", "Mondésir"] },
  { slug: "le-taillan-medoc", name: "Le Taillan-Médoc", insee: "33527", postal: "33320",
    blurb: "Porte du Médoc, anciennes propriétés viticoles, traitements bois fréquents.",
    neighborhoods: ["Centre", "Cantelaude", "Germignan"] },
  { slug: "pauillac", name: "Pauillac", insee: "33314", postal: "33250",
    blurb: "Cœur du Médoc viticole : châteaux, chais, et habitat de prestige à protéger.",
    neighborhoods: ["Centre", "Le Pouyalet", "Saint-Lambert"] },
  { slug: "lesparre-medoc", name: "Lesparre-Médoc", insee: "33240", postal: "33340",
    blurb: "Médoc nord, bâtis ruraux et anciennes maisons médocaines.",
    neighborhoods: ["Centre", "Saint-Trélody", "L'Hôpital"] },
  { slug: "castelnau-de-medoc", name: "Castelnau-de-Médoc", insee: "33106", postal: "33480",
    blurb: "Médoc viticole, anciennes maisons en pierre, charpentes en chêne.",
    neighborhoods: ["Centre", "Lestage", "Liroulet"] },
  { slug: "macau", name: "Macau", insee: "33260", postal: "33460",
    blurb: "Bord de Garonne médocaine, humidité et risque termites importants.",
    neighborhoods: ["Centre", "Le Port", "Bouqueyran"] },
  { slug: "castres-gironde", name: "Castres-Gironde", insee: "33116", postal: "33640",
    blurb: "Sud bordelais, anciennes maisons girondines en pierre calcaire.",
    neighborhoods: ["Centre", "Bourg", "Plassac"] },
  { slug: "cestas", name: "Cestas", insee: "33122", postal: "33610",
    blurb: "Vaste commune forestière, pavillons en pin maritime : capricornes endémiques.",
    neighborhoods: ["Centre", "Gazinet", "Le Bourg"] },
  { slug: "canejan", name: "Canéjan", insee: "33090", postal: "33610",
    blurb: "Sud Bordeaux, pavillons résidentiels en lisière forestière.",
    neighborhoods: ["Centre", "Cap-de-Bos", "Sentous"] },
  { slug: "cadaujac", name: "Cadaujac", insee: "33080", postal: "33140",
    blurb: "Sud bordelais, propriétés bourgeoises et pavillons des années 70.",
    neighborhoods: ["Centre", "Lartigue", "Bigot"] },
  { slug: "saint-jean-d-illac", name: "Saint-Jean-d'Illac", insee: "33422", postal: "33127",
    blurb: "Pinède girondine, charpentes en pin, fortes attaques de xylophages.",
    neighborhoods: ["Centre", "Lapouyade", "Issac"] },
  { slug: "marcheprime", name: "Marcheprime", insee: "33500", postal: "33380",
    blurb: "Entre Bordeaux et Arcachon, pavillons et maisons forestières.",
    neighborhoods: ["Centre", "Croix d'Hins", "Le Bourg"] },
  { slug: "biganos", name: "Biganos", insee: "33051", postal: "33380",
    blurb: "Bassin d'Arcachon est, zones humides et villas en bois exposées.",
    neighborhoods: ["Centre", "Facture", "Lamothe"] },
  { slug: "gujan-mestras", name: "Gujan-Mestras", insee: "33199", postal: "33470",
    blurb: "Bassin sud : ports ostréicoles, villas balnéaires, charpentes humides.",
    neighborhoods: ["Centre", "La Hume", "Le Téchan"] },
  { slug: "le-teich", name: "Le Teich", insee: "33527", postal: "33470",
    blurb: "Réserve ornithologique, zone humide majeure : risque termites et mérule.",
    neighborhoods: ["Centre", "Le Delta", "Bourg"] },
  { slug: "lege-cap-ferret", name: "Lège-Cap-Ferret", insee: "33236", postal: "33950",
    blurb: "Presqu'île de Lège-Cap-Ferret : villas en bois, climat salin, vrillettes.",
    neighborhoods: ["Cap-Ferret", "Lège", "Claouey", "Piraillan"] },
  { slug: "ares", name: "Arès", insee: "33011", postal: "33740",
    blurb: "Bassin nord, villas anciennes en bois, capricornes et vrillettes signalés.",
    neighborhoods: ["Centre", "Saint-Brice", "Ouroué"] },
  { slug: "audenge", name: "Audenge", insee: "33019", postal: "33980",
    blurb: "Bassin d'Arcachon, anciens ports ostréicoles, maisons humides.",
    neighborhoods: ["Centre", "Cassy", "Jacotin"] },
];

export const FAQ = [
  {
    q: "L'expertise termites est-elle obligatoire à Bordeaux ?",
    a: "Oui. La Gironde est classée en zone à risque par arrêté préfectoral. Tout vendeur d'un logement situé dans une commune déclarée infestée doit fournir une expertise parasitaire de moins de 6 mois lors de la signature de l'acte authentique.",
  },
  {
    q: "Combien coûte un traitement termites à Bordeaux ?",
    a: "Le tarif dépend de la surface traitée, du type de bâti et du protocole (injection ou pièges-appâts). Comptez en moyenne entre 80 et 140 € HT du mètre linéaire. Un devis détaillé est systématiquement remis avant toute intervention.",
  },
  {
    q: "Quelle différence entre termites, capricornes et vrillettes ?",
    a: "Les termites sont des insectes sociaux qui vivent en colonie et attaquent le bois depuis l'intérieur, sans signes extérieurs. Les capricornes et vrillettes sont des coléoptères xylophages : on observe des trous de sortie et de la sciure. Les protocoles de traitement diffèrent.",
  },
  {
    q: "Combien de temps dure une intervention ?",
    a: "Une expertise complète prend 1 à 3 heures selon la surface. Un traitement curatif charpente classique prend 1 à 2 jours pour une maison individuelle. L'injection termites peut s'étaler sur 2 à 4 jours.",
  },
  {
    q: "Quelle garantie est offerte sur le traitement ?",
    a: "Tous nos traitements sont garantis 5 ans. Concrètement : si une nouvelle infestation est constatée dans les 5 ans suivant notre intervention, nous revenons traiter à nos frais, sans le moindre euro à votre charge.",
  },
  {
    q: "Intervenez-vous dans toute la Gironde ?",
    a: "Oui : Bordeaux Métropole, Bassin d'Arcachon, Libournais, Médoc, Blayais, Entre-deux-mers, Bazadais. Nos équipes se déplacent dans toutes les communes du département.",
  },
  {
    q: "Comment savoir si ma maison a des termites ?",
    a: "Plusieurs indices peuvent alerter : cordonnets de terre le long des murs, bois qui sonne creux au toucher, présence d'ailes d'insectes au sol au printemps, sciure fine. Au moindre doute, demandez une expertise gratuite.",
  },
  {
    q: "Le produit de traitement est-il dangereux ?",
    a: "Les produits utilisés sont homologués par l'Agence nationale de sécurité sanitaire (Anses) et certifiés CTB‑P+. Ils sont sans danger pour les occupants après séchage. Un délai de réintégration de 4 à 8 h est généralement préconisé.",
  },
  {
    q: "Quel délai pour intervenir à Bordeaux ?",
    a: "Sur Bordeaux Métropole, un premier rendez‑vous d'expertise est proposé sous 48 h. Pour les urgences (essaimage, vente en cours), nous intervenons sous 24 h.",
  },
  {
    q: "Peut-on traiter les termites sans casser les murs ?",
    a: "Oui, dans la majorité des cas. Les protocoles d'injection passent par des micro‑perçages discrets, ensuite rebouchés. Les pièges‑appâts ne requièrent aucune intervention sur les murs : ils sont installés en périmètre extérieur.",
  },
];

export const REVIEWS = [
  {
    name: "Camille R.",
    city: "Bordeaux",
    date: "2025-07",
    rating: 5,
    text: "Traitement effectué suite à une invasion de termites. Entreprise sérieuse et professionnelle, je recommande vivement.",
  },
  {
    name: "Jérôme D.",
    city: "Mérignac",
    date: "2025-06",
    rating: 5,
    text: "Très professionnel. À l'écoute et propose un traitement efficace et adapté. Je recommande sans aucune hésitation.",
  },
  {
    name: "Sophie L.",
    city: "Pessac",
    date: "2025-04",
    rating: 5,
    text: "Intervention suite à un problème de termites. Professionnel, sérieux et de très bon conseil, ce qui n'est pas évident dans ce genre de problème. Je le recommande vivement.",
  },
  {
    name: "Pierre M.",
    city: "Le Bouscat",
    date: "2025-03",
    rating: 5,
    text: "Entreprise sérieuse et réactive.",
  },
  {
    name: "Hélène G.",
    city: "Talence",
    date: "2025-02",
    rating: 5,
    text: "Expertise obligatoire pour notre vente. Rapport clair, intervention soignée et conseils précieux.",
  },
  {
    name: "Marc V.",
    city: "Bègles",
    date: "2025-01",
    rating: 5,
    text: "Excellente expertise sur notre maison ancienne. Cave traitée contre la mérule, plus de soucis depuis.",
  },
];
